import styled from 'styled-components';

export const TooltipContainer = styled.div`
  position: absolute;
  z-index: 2;
  background-color: ${({ theme }): string => theme.colors.white};
  box-shadow: 0px 5px 10px 0px ${({ theme }): string => theme.colors.boxShadowDarker};
  padding: 10px;
  transition: opacity 0.3s ease;
  pointer-events: none;
  width: 265px;
`;
